<template>
  <div :class="['app-container', { 'bdc-list-page': isBdc }]">

    <!-- 工具栏 -->
    <div v-if="!isBdc" class="filter-container" :class="{ 'bdc-filter-bar': isBdc }">
      <div class="filterTableHeader" :class="{ 'bdc-list-toolbar-actions': isBdc }">
        <el-popover width="400" trigger="click">
          <el-button slot="reference" size="small" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
              <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item" >{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </div>
    </div>

    <!-- 表格 -->
    <div ref="bdcTableArea" :class="{'bdc-table-area': isBdc}">
    <el-table class="grayTableTile" size="mini"  v-loading="listLoading" :data="tableData" border style="width: 100%" :height="tableHeightDaily">
      <el-table-column v-for="(item,index) in tableTheads" :key="index" :label="item[Object.keys(item)[0]]" :prop="Object.keys(item)[0]" :min-width="Object.keys(item)[0] == 'method' ? '140px' : Object.keys(item)[0] == 'addTime'? '80px': '110px'">
        <template slot-scope="scope" >
          <span v-if="Object.keys(item)[0] == 'respParam'" @click="jinruyouxi(scope.row.respParam)" style="color:#646cf5;cursor: pointer;">{{ scope.row[Object.keys(item)[0]] | neirongsuojian}}</span>
          <span v-else>{{ scope.row[Object.keys(item)[0]]}}</span>
        </template>
      </el-table-column>
    </el-table>
    </div>

     <!-- 分页 -->
    <bdc-table-footer>
      <template #actions>
        <el-popover width="400" trigger="click">
          <bdc-column-filter-button slot="reference" />
          <el-checkbox-group class="checkbox-table-headers" v-model="checkboxTitle">
              <el-checkbox v-for="(item,index) in tableTheadOptions" :key="index" :label="item" >{{item[Object.keys(item)[0]]}}</el-checkbox>
          </el-checkbox-group>
        </el-popover>
      </template>
      <pagination v-show="total>0" :auto-scroll="false" :background="!isBdc" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" :class="isBdc ? 'bdc-table-pagination' : ''" @pagination="getList" />
    </bdc-table-footer>
    

     <!-- 返回内容全内容展示 并且可以复制 -->
    <el-dialog class="dialog-box" v-if="infoDialog" title="事件返回内容" :visible.sync="infoDialog" append-to-body width="1200px" top="5vh">
      <div class="wrapper">
        <json-editor ref="jsonEditor" v-model="jsontext" />
      </div>
    </el-dialog>
    
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import BdcTableFooter from '@/components/BdcTableFooter'
import BdcColumnFilterButton from '@/components/BdcTableFooter/BdcColumnFilterButton'
import JsonEditor from '@/components/JsonEditor'
import {loglist} from '@Sys~/api/sys'
import Store from '@Sys~/store'
import bdcListTableHeight from '@Sys~/utils/bdcListTableHeight'
const defaultFormThead = [
  {modul: '名称'},
  {method: '方法'},
  {requParam: '请求参数'},
  {respParam: '返回内容'},
  {username: '操作员名称'},
  {addTime: '操作时间'},
  {url: 'url地址'},
  {ip: '操作ip'}
]

const name = Store.getters.currentRoute.name
console.log('缓存===',Store.getters.currentRoute.meta.title, name)
export default {
  name:name,
  mixins: [bdcListTableHeight],
  components: {Pagination, BdcTableFooter, BdcColumnFilterButton, JsonEditor},
  data() {
    return {
       // 表格
      listLoading: false,
      tableData: [], 
      tableTheadOptions:defaultFormThead,
      checkboxTitle:defaultFormThead,
      tableTheads:defaultFormThead,
      
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      jsontext: null,
      infoDialog: false
    }
  },
  filters: {
    neirongsuojian(value) {
      return value.substring(0,25)+"...";
    },
  },
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    }
  },
  watch: {
    // 筛选table header
    checkboxTitle(valArr) {
      this.tableTheads = this.tableTheadOptions.filter(i => JSON.stringify(valArr).indexOf(JSON.stringify(i)) > -1)
      // console.log('=======',this.tableTheads)
    }
  },
  created() {
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      this.listLoading = true
      loglist(this.listQuery).then(response => {
          this.listLoading = false
          if (response.code == 1) {
            this.tableData = response.data.result;
            this.total = response.data.totalCount;
          }
        }
      );
    },

    // 返回内容详情
    jinruyouxi(row) {
      this.infoDialog = true
      this.jsontext = JSON.parse(row)
    }
  }
}
</script>

<style lang="scss" scoped>
  .dialog-box{
    ::v-deep .el-dialog__body{
      height: 750px;
      padding-top: 0;
    }
    .wrapper {
      width: 100%;
      height: 100%;
      overflow:scroll ;
    }
  }
</style>